export default __webpack_public_path__ + "static/media/accessible-three-scene.2647844f.mp4";